module.exports = __webpack_public_path__ + "static/media/image-web-1.1ea12665.png";